export const INACTIVE_DEALER_WARNING_ID = 'inactiveDealerWarningId';

function shouldShowInactiveDealerWarning({
  isLimitedUser,
  hasAccess,
  excludeAnnouncementsFromPage,
}) {
  return isLimitedUser && hasAccess && !excludeAnnouncementsFromPage;
}

function buildInactiveDealerWarningToast(currentUser) {
  return {
    id: INACTIVE_DEALER_WARNING_ID,
    header: currentUser.inactiveMessage.title,
    severity: 'warning',
    message: currentUser.inactiveMessage.text,
    dismissible: false,
  };
}

/**
 * Decides what, if anything, should happen to the inactive-dealer warning toast.
 * Returns 'show', 'clear', or null (no change needed).
 */
function resolveInactiveDealerWarningSync({
  routeName,
  isLimitedUser,
  hasAccess,
  excludeAnnouncementsFromPage,
  toastMessages,
}) {
  if (!routeName) {
    return null;
  }

  const alreadyShowingWarning = toastMessages
    .some((toastMessage) => toastMessage.id === INACTIVE_DEALER_WARNING_ID);

  if (shouldShowInactiveDealerWarning({ isLimitedUser, hasAccess, excludeAnnouncementsFromPage })) {
    return alreadyShowingWarning ? null : 'show';
  }

  return alreadyShowingWarning ? 'clear' : null;
}

export default function useInactiveDealerWarning() {
  return {
    inactiveDealerWarningId: INACTIVE_DEALER_WARNING_ID,
    buildInactiveDealerWarningToast,
    resolveInactiveDealerWarningSync,
  };
}
